import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { post, errMsg } from "@/lib/api";
import { Logo, Field, Btn } from "@/components/kit";

export default function DsaRegister() {
  const [f, setF] = useState({ agreement_accepted: false });
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try { const r = await post("/auth/register-dsa", f); setDone(r.data); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const P = { form: f, setForm: setF };
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="mx-auto max-w-3xl">
        <Link to="/"><Logo /></Link>
        <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
          {done ? (
            <div className="py-10 text-center" data-testid="dsa-register-success">
              <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" />
              <h2 className="mt-4 font-display text-2xl font-bold">Registration received</h2>
              <p className="mt-2 text-slate-600">Your DSA ID is <b className="font-mono" data-testid="dsa-code">{done.dsa_code}</b>. Our team will verify your KYC & agreement and activate your account.</p>
              <Link to="/login?tab=partner" className="mt-6 inline-block text-sm font-semibold text-blue-800">Go to partner login →</Link>
            </div>
          ) : (
            <>
              <h1 className="font-display text-2xl font-bold">DSA / Channel Partner Registration</h1>
              <p className="mt-1 text-sm text-slate-500">Accounts are activated after FinOrbit verification.</p>
              <h3 className="mt-6 text-xs font-bold uppercase tracking-wider text-slate-400">Personal & KYC</h3>
              <div className="mt-2 grid gap-4 md:grid-cols-2">
                <Field label="Full name" name="name" required {...P} />
                <Field label="Mobile" name="mobile" required {...P} />
                <Field label="Email" name="email" type="email" required {...P} />
                <Field label="Password" name="password" type="password" required hint="8+ chars, letters & numbers" {...P} />
                <Field label="PAN" name="pan" required {...P} />
                <Field label="Aadhaar (last 4 digits)" name="aadhaar_last4" {...P} />
                <Field label="Address" name="address" className="md:col-span-2" {...P} />
                <Field label="City" name="city" {...P} />
                <Field label="State" name="state" {...P} />
              </div>
              <h3 className="mt-6 text-xs font-bold uppercase tracking-wider text-slate-400">Business & bank</h3>
              <div className="mt-2 grid gap-4 md:grid-cols-2">
                <Field label="Business name" name="business_name" {...P} />
                <Field label="Business type" name="business_type" options={["INDIVIDUAL", "PROPRIETORSHIP", "PARTNERSHIP", "PRIVATE_LIMITED", "LLP"]} {...P} />
                <Field label="GSTIN (if applicable)" name="gstin" {...P} />
                <Field label="Referral code" name="referral_code" {...P} />
                <Field label="Bank account no." name="bank_account_no" {...P} />
                <Field label="IFSC" name="bank_ifsc" {...P} />
              </div>
              <p className="mt-4 text-xs text-slate-500">Documents (PAN, Aadhaar, cancelled cheque, agreement) can be submitted after activation - <span className="font-semibold">Coming Soon</span> in partner profile.</p>
              <label className="mt-4 flex items-start gap-2 text-sm">
                <input data-testid="dsa-agreement-checkbox" type="checkbox" checked={f.agreement_accepted} onChange={(e) => setF({ ...f, agreement_accepted: e.target.checked })} className="mt-1" />
                I accept the FinOrbit DSA agreement and code of conduct, and consent to verification of my KYC details.
              </label>
              <Btn data-testid="dsa-register-submit" className="mt-6 w-full md:w-auto" loading={busy} onClick={submit}>Submit registration</Btn>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
